// extracted by mini-css-extract-plugin
module.exports = {"solid":"OverlayBackground_solid__PVJRx","gradient":"OverlayBackground_gradient__ehZEk"};